import { Accordion } from "react-bootstrap";

export default function EditorFaq(props) {
    return (
        <div className="mt-5">
            <h2>Editor FAQs</h2>
            <Accordion flush>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Why do other colors change when I place a tile?</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            The NES is extremely limited in it's ability to show graphics. In addition to having a very limited
                            number of available tiles, it is also limited in how much colors can vary.
                        </p>
                        <p>
                            To save resources, the NES stores palettes separately from the graphics, and only allows using one of
                            the four palettes for each 16x16 pixel area. NES tiles are 8x8 pixels, so this means that any palette change
                            affects all 4 palettes in the grouping.
                        </p>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                    <Accordion.Header>Why does the editor sometimes "lag" when typing or drawing 8x8 tiles?</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            This is a bug that is unfortunately very hard to solve. 
                        </p>
                        <p> 
                            In short, we have to load a bunch of different images to 
                            show each character - there are 128 tiles available to you, in 4 palettes. We have to redraw this with each palette, so 
                            this requires your browser to have 512 images at the ready. Doing this in one big block makes the browser rather upset with
                            us, so we opt to load only the tiles you need, or we think you might need. 
                            In addition, when drawing 8x8 tiles with a different tile palette, we have to update the 3 other surrounding tiles at the same time,
                            which may also need to be loaded ad-hoc. 
                        </p>
                        <p>
                            This is certainly a solveable problem, however it takes a lot of time and effort.
                            It seemed more important to get a working tool out for you, rather than polish every rough edge to perfection.
                            It takes a little bit of
                            patience, but the tool works. If this is a big hassle for you, definitely share your frustration and this can be worked
                            on soon.
                        </p>
                    </Accordion.Body>
                </Accordion.Item>

                {props.children}
            </Accordion>
        </div>
    )    
}
